import script from "./OTRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./OTRecord.vue?vue&type=script&setup=true&lang=js"

import "./OTRecord.vue?vue&type=style&index=0&id=1dd94397&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dd94397"]])

export default __exports__